/**
 * #4420 — compatibilidade do campo de férias coletivas com o que já está
 * gravado.
 *
 * A coluna é texto e carrega dois formatos: `"AAAA-MM-DD"` (gravado quando o
 * campo era `type="date"`) e `"AAAA-MM-DDTHH:MM"` (a tela nova, com hora).
 *
 * Um `<input type="datetime-local">` só exibe o segundo: recebendo uma data
 * pura ele renderiza **vazio**. O operador abriria a conexão, veria os campos
 * de férias em branco e, ao salvar qualquer outra coisa na tela, apagaria o
 * período sem perceber.
 *
 * Por isso a data pura é completada ao ENTRAR na tela — início às 00:00 e fim
 * às 23:59, o mesmo significado que o backend dá a ela
 * (`collectiveVacationWindow.ts`). As duas pontas precisam concordar: se a
 * tela escolhesse outra hora, salvar sem querer encurtaria as férias.
 */

/** Horas-padrão por ponta, quando o valor gravado não tem hora. */
const DEFAULT_TIME = { start: "00:00", end: "23:59" };

/**
 * Valor pronto para um `<input type="datetime-local">`.
 *
 * Devolve `""` (e não `null`) para vazio/inválido, porque é o que o input
 * controlado do React espera — `null` faz o campo virar não-controlado e o
 * React avisa no console.
 */
export function toDateTimeLocal(value, edge = "start") {
  if (!value || typeof value !== "string") return "";

  const trimmed = value.trim();
  if (trimmed === "") return "";

  // Já tem hora: corta segundos/timezone, que o input não aceita.
  if (trimmed.includes("T")) {
    const [date, time = ""] = trimmed.split("T");
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return "";
    const hhmm = time.slice(0, 5);
    if (!/^\d{2}:\d{2}$/.test(hhmm)) {
      return `${date}T${DEFAULT_TIME[edge] || DEFAULT_TIME.start}`;
    }
    return `${date}T${hhmm}`;
  }

  if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return "";
  return `${trimmed}T${DEFAULT_TIME[edge] || DEFAULT_TIME.start}`;
}

/**
 * Normaliza as duas pontas de férias de um registro vindo da API, sem tocar no
 * resto. Usado ao carregar a conexão no formulário.
 */
export function normalizeVacationFields(whatsapp) {
  if (!whatsapp || typeof whatsapp !== "object") return whatsapp;

  return {
    ...whatsapp,
    collectiveVacationStart: toDateTimeLocal(
      whatsapp.collectiveVacationStart,
      "start"
    ),
    collectiveVacationEnd: toDateTimeLocal(whatsapp.collectiveVacationEnd, "end"),
  };
}
